// utils/Mapejos.js

// Mapeig per a Tipus d'Entitat
const tipusEntitatMap = {
    Particular: "Particular",
    Empresa: "Empresa",
    Autonom: "Autònom",
  };
  
  // Mapeig per a Tipus de Via
  const tipusViaMap = {
    Carrer: "Carrer",
    Avinguda: "Avinguda",
    Passatge: "Passatge",
    Passeig: "Passeig",
    Carretera: "Carretera",
    Urbanitzacio: "Urbanització",
    Placa: "Plaça",
    Cami: "Camí",
    Rambla: "Rambla",
    Travessera: "Travessera",
    Ronda: "Ronda",
    Parc: "Parc",
    "Poligon Industrial": "Polígon Industrial",
    Altres: "Altres",
  };

  // Mapeig per a Tipus de Via de Consulta
export const tipusViaCons = {
  Carrer: "C.",
  Avinguda: "Av.",
  Passatge: "Ptge.",
  Passeig: "Pg.",
  Carretera: "Ctra.",
  Urbanitzacio: "Urb.",
  Placa: "Pça.",
  Cami: "Camí",
  Rambla: "Rbla.",
  Travessera: "Trav.",
  Ronda: "Rda.",
  Parc: "Parc",
  "Poligon Industrial": "Pol. Ind.",
  Altres: "Altres",
};


  // Mapeig per a Qualitat
const qualitatMap = {
    Pessima: "Pèssima",
    Baixa: "Baixa",
    Mitjana: "Mitjana",
    Alta: "Alta",
    Maxima: "Màxima",
  };

  const estatVersio = {
    Esborrany: "Esborrany",
    Presentat: "Presentada",
    Acceptat: "Acceptada",
    Rebutjat: "Rebutjada",
  };

  //Mapeig de tipus de treballs
  const tipusTreballMap = {
    Manteniment: "Manteniment",
    Obra: "Obra",
    Reparacio: "Reparació",
    Altres: "Altres",
  };

  
  // Funció genèrica per transformar valors cap a presentació
  export function mapToPresentable(value, map) {
    if (!value || !map) return value; // Retorna el valor original si no hi ha valor o mapa
    return map[value] || value; // Retorna el valor del mapa o l'original si no hi ha coincidència
  }
  
  // Funció genèrica per transformar valors cap a base de dades
  export function mapToDatabase(value, map) {
    if (!value || !map) return value; // Retorna el valor original si no hi ha valor o mapa
  
    // Invertim el mapa
    const invertedMap = {};
    Object.entries(map).forEach(([key, val]) => {
      invertedMap[val] = key; // Invertim clau/valor
    });
  
    return invertedMap[value] || value; // Retorna el valor del mapa invers o l'original si no hi ha coincidència
  }
  
  const estatTascaMap = {
    Pendent: "Pendent",
    "En curs": "En curs",
    Acabat: "Acabada",
  };

  const prioritatTascaMap = {
    Urgent: "Urgent",
    Alta: "Alta",
    Mitjana: "Mitjana",
    Baixa: "Baixa",
  };

  const tipusTascaMap = {
    Normal: "Normal",
    Ciclica: "Cíclica",
  };

  const tipusFacturacioMap = {
    Inclosa_pressupost: "Inclosa pressupost",
    Extra: "Extra",
    No_facturable: "No facturable",
    Facturable: "Facturable",
    Pendent: "Pendent",
  };

  const tipusDependenciaMap = {
    Excloent: "Excloent",
    Pred: "Predecessora",
  };

  const freqTascaMap = {
    S: "Setmanal",
    Q: "Quinzenal",
    M: "Mensual",
    "2M": "Bimestral",
    "3M": "Trimestral",
    "4M": "Quadrimestral",
    "6M": "Semestral",
    A: "Anual",
  };

  const estatAgrupacioMap = {
    Pendent: "Pendent",
    "En curs": "En curs",
    Acabada: "Acabada",
  };

  const unitatsMesuraMap = {
    ml: "ml",
    m2: "m²",
    ut: "ut",
    m3: "m³",
    l: "l",
    Pa: "Pa",
    gr: "gr",
    kg: "kg",
  };

  const unitatsTempsMap = {
    Minuts: "Minuts",
    Hores: "Hores",
    Dies: "Dies",
    Setmanes: "Setmanes",
    Mesos: "Mesos",
  };

  const origenProducteMap = {
    PENDENT: "Pendent",
    ESTOC: "Estoc",
    PROVEIDOR: "Proveïdor",
  };

  // Mapeig per a Empleats.ControlHorari
  const controlHorariMap = {
    OBLIGATORI: "Obligatori",
    OPCIONAL: "Opcional",
    NO_APLICA: "No aplica",
  };

  const nivellPermisAgendaMap = {
    0: "Privat",
    1: "Equip",
    2: "Empresa",
    3: "Públic",
  };

  // Recursos: Vehicles.TipusVehicle i Eines.Estat (els valors de BD no es toquen)
  const tipusVehicleMap = {
    FURGONETA: "Furgoneta",
    TURISME: "Turisme",
    CAMIO: "Camió",
    MOTO: "Moto",
    ALTRE: "Altre",
  };

  const estatEinaMap = {
    OPERATIVA: "Operativa",
    AVARIADA: "Avariada",
    REPARACIO: "En reparació",
    BAIXA: "Baixa",
    PERDUDA: "Perduda",
  };

  const tipusUbicacioMap = {
    MAGATZEM: "Magatzem",
    OBRA: "Obra",
    VEHICLE: "Vehicle",
    ALTRE: "Altre",
  };

  // Exportem mapes per reutilització i manteniment
  export const mapejos = {
    tipusUbicacio: tipusUbicacioMap,
    tipusVehicle: tipusVehicleMap,
    estatEina: estatEinaMap,
    tipusEntitat: tipusEntitatMap,
    tipusVia: tipusViaMap,
    qualitat: qualitatMap,
    estatVersio: estatVersio,
    tipusTreballMap: tipusTreballMap,
    estatTasca: estatTascaMap,
    prioritatTasca: prioritatTascaMap,
    tipusTasca: tipusTascaMap,
    tipusFacturacio: tipusFacturacioMap,
    tipusDependencia: tipusDependenciaMap,
    freqTasca: freqTascaMap,
    estatAgrupacio: estatAgrupacioMap,
    unitatsMesura: unitatsMesuraMap,
    unitatsTemps: unitatsTempsMap,
    origenProducte: origenProducteMap,
    controlHorari: controlHorariMap,
    nivellPermisAgenda: nivellPermisAgendaMap,
  };
  